import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconoirNavArrowDown } from '@ey-xd/motif-icon';
import EditTrsTable from './EditTrsTable';
import EditTrsForm from './EditTrsForm';
import {
  MotifButton,
  MotifModal,
  MotifDropdown,
  MotifIcon,
  MotifDropdownItem,
} from '@ey-xd/motif-react';

const EditTrsComponent = ({
  taxableReitSubsidiaries,
  showForm,
  handleCloseForm,
  handleSubmit,
  formPurpose,
  selectedTrs,
  handleEditButtonClick,
  handleDeleteButtonClick,
  canEdit,
  handleDismissErrorMessage,
  handleExportTRSQuarterlyDataImportTemplate,
  handleUploadTRSImportTemplate,
}) => {
  // Demonstrates how to set initial form values for use when editing
  const initialValuesTest = {
    name: '',
  };
  const [actionOptionsOpen, setActionOptionsOpen] = useState(false);

  return (
    <div className="edit-trs-component">
      <div className="row align-items-center" style={{ marginBottom: '10px' }}>
        <div className="col-md-10 pl-15">
          <h2>Taxable REIT Subsidiaries {canEdit ? '' : '- Testing Closed'}</h2>
        </div>
        {Array.isArray(taxableReitSubsidiaries) &&
          taxableReitSubsidiaries.length > 0 && (
            <div className="col-md-2 d-flex justify-content-end">
              <MotifDropdown
                open={actionOptionsOpen}
                placement="bottom-end"
                id={'action-dropdown'}
                className="master-data-dropdown-action"
                handleClickOutside={() => setActionOptionsOpen(false)}
                trigger={
                  <MotifButton
                    type="button"
                    variant="primary"
                    onClick={() => setActionOptionsOpen(!actionOptionsOpen)}
                    aria-controls={'action-dropdown'}
                    id={'action-dropdown-trigger'}
                    aria-expanded={actionOptionsOpen}
                    aria-label="Action dropdown"
                    data-testid="btnActions"
                  >
                    Actions{' '}
                    <MotifIcon
                      iconFunction={IconoirNavArrowDown}
                      size="24"
                      fill="none"
                    />
                  </MotifButton>
                }
              >
                <ul role="menu">
                  <li role="menuitem">
                    <MotifDropdownItem
                      type="button"
                      data-testid="btnExportPropertiesOwnership%"
                      className="master-dropdown-item"
                      onClick={handleExportTRSQuarterlyDataImportTemplate}
                    >
                      Export TRS Quarterly Data
                    </MotifDropdownItem>
                  </li>
                  <li role="menuitem">
                    <MotifDropdownItem
                      type="button"
                      data-testid="btnUploadPropertiesOwnership%"
                      className="master-dropdown-item"
                      onClick={handleUploadTRSImportTemplate}
                    >
                      Upload TRS Quarterly Data
                    </MotifDropdownItem>
                  </li>
                </ul>
              </MotifDropdown>
            </div>
          )}
      </div>
      <div>
        <EditTrsTable
          taxableReitSubsidiaries={taxableReitSubsidiaries}
          handleEditButtonClick={handleEditButtonClick}
          canEdit={canEdit}
        />
      </div>
      <MotifModal
        show={showForm}
        area-label="Add or Edit TRS"
        variant="alt"
        size="lg"
        onClose={handleCloseForm}
      >
        <EditTrsForm
          onSubmit={handleSubmit}
          handleCloseForm={handleCloseForm}
          initialValues={selectedTrs}
          formPurpose={formPurpose}
          handleDismissErrorMessage={handleDismissErrorMessage}
        />
      </MotifModal>
    </div>
  );
};

EditTrsComponent.propTypes = {
  showForm: PropTypes.bool.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
  handleNewButtonClick: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  taxableReitSubsidiaries: PropTypes.arrayOf(
    PropTypes.shape({
      taxableREITSubsidiaryID: PropTypes.number,
      reportPeriodID: PropTypes.number,
      trsName: PropTypes.string,
      trsValue: PropTypes.number,
      trsDebt: PropTypes.number,
      trsEquity: PropTypes.number,
      reitTrackingID: PropTypes.string,
    })
  ),
  formPurpose: PropTypes.string,
  selectedTrs: PropTypes.object,
  handleEditButtonClick: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  handleDismissErrorMessage: PropTypes.func,
  handleExportTRSQuarterlyDataImportTemplate: PropTypes.func.isRequired,
  handleUploadTRSImportTemplate: PropTypes.func.isRequired,
};

export default EditTrsComponent;
